import {Injectable, Inject} from 'ng-metadata/core';
import {getInstitutionCode,getBackendSystem} from '../../appConfig/appConfigForward';


const endsWith= require('lodash/endsWith');
const orderBy= require('lodash/orderBy');


@Injectable()
export class VirtualBrowseService {
    private callNumberBrowseField: string;
    constructor(@Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs: any,
                @Inject('$location') private $location: ng.ILocationService,
                @Inject('$state') private $state: angular.ui.IStateService,
                @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService) {
    }


    public buildRestApiInitialParams(virtualBrowseObject: any): IVirtualBrowseApiParams{
        this.type= undefined;
        let params: IVirtualBrowseApiParams={callNumber: '', callNumberBrowseField: '', institution: getInstitutionCode(), position: 'CENTER', numOfRecords: 40};
        params.callNumberBrowseField= virtualBrowseObject.callNumberBrowseField;
        params.callNumber= virtualBrowseObject.callNumber;
        return params;
    }


    public callVirtualBrowseApi(params: IVirtualBrowseApiParams){
        return this.$http.get(this.restBaseURLs.browse,{params: params});
    }

    public parseVirtualBrowseApiResponse(response: IBrowseShelfResponse):IVirtualBrowseObject{
        let virtualBrowsItems: Array<VirtualBrowseItem>= [];
        for (let item of response.browseShelfItems){
            virtualBrowsItems.push(new VirtualBrowseItem(item));
        }
        return {virtualBrowseItems: virtualBrowsItems, nextTerm:response.nextTerm, backTerm: response.backTerm, currTerm: response.currTerm, browseField: response.browseField};
    }

    public getStateName(){
        switch (this.$state.current.name) {
            case 'exploreMain.search':
                return 'fulldisplay';
            case 'exploreMain.jsearch':
                return 'jfulldisplay';
            default :
                return this.$state.current.name;
        }

    }

    public navigateToItemFullView(virtualBrowseItem: VirtualBrowseItem){
        let params= this.$location.search();
        if (getBackendSystem() === 'suprima'){
            params.virtualBrowse='true';
        }
        if (getBackendSystem() === 'suprima' && this.$state.current.name === 'servicesPage') {
			params['rft.mms_id']= virtualBrowseItem.recordId.replace('alma','');
            params.rft_dat='ie=';
            params.ie=undefined;
            this.$state.go('servicesPage', params, {reload: true});
        } else if (getBackendSystem() === 'suprima' && (this.$state.current.name === 'jfulldisplay' || this.$state.current.name === 'exploreMain.jsearch' )) {
            params.docid= virtualBrowseItem.recordId;
        	this.$state.go('jfulldisplay', params, {reload: true});
        } else {
            params.docid= virtualBrowseItem.recordId;
        	this.$state.go('fulldisplay', params, {reload: true});
        }
        this.$mdDialog.hide();
    }

    public getItemFullViewParams(virtualBrowseItem: VirtualBrowseItem){
        if (!virtualBrowseItem){
            return undefined;
        }
        let params = angular.copy(this.$location.search());
        if (getBackendSystem() === 'suprima' && this.$state.current.name === 'servicesPage') {
           params['rft.mms_id']= virtualBrowseItem.recordId.replace('alma','');
           params.rft_dat='ie=';
           params.ie=undefined;
        }
        else {
            params.docid= virtualBrowseItem.recordId;
        }
        return params;
    }

    public getDisplayCallNumber(callNumberArray: Array<string>, selectedCallNumber: string){
        let splitedCallNumberArr= callNumberArray.map((str)=>str.split('$$'));
        let selectedCallNumberArr= splitedCallNumberArr.filter((arr)=>{let cN=arr.filter((str)=>str.charAt(0) === 'E')[0] || '';  return cN.substring(1) === selectedCallNumber})[0];
        for (let s of selectedCallNumberArr){
            if (s.charAt(0) === 'D'){
                return s.substring(1);
            }
        }
    }

}



export interface IVirtualBrowseApiParams{
    callNumber: string;
    callNumberBrowseField: string;
    numOfRecords: number;
    position?: string;
    institution?: string; //TODO: this should probably be taken from JWT and not sent as para, to API
}

export interface IBrowseShelfResponse{
    browseShelfItems: Array<IBrowseShelfItem>;
    nextTerm: string;
    backTerm: string;
    currTerm: string;
    browseField: string;
}

export interface IBrowseShelfItem{
    recordId: string;
    callNumber: string;
    author: string;
    date: string;
    title: string;
    thumbnails: IBrowseShelfThumbnails;
}

export interface IBrowseShelfThumbnails{
    url: Array<string>;
}

export interface IVirtualBrowseObject{
    virtualBrowseItems: Array<VirtualBrowseItem>;
    nextTerm: string;
    backTerm: string;
    currTerm: string;
    browseField: string;
}


export class VirtualBrowseItem {
    public callNumber: string;
    public title: string;
    public author: string;
    public date: string;
    public recordId: string;
    public thumbnails: Array<string>;
    public thumbnail: string;
    public isSelectedRecord: boolean = false; //this boolean signals if this is the item who's full view is open

    constructor(browseShelfItem: IBrowseShelfItem){
        this.callNumber= browseShelfItem.callNumber;
        this.title= browseShelfItem.title;
        this.author= browseShelfItem.author;
        this.date= browseShelfItem.date;
        this.recordId= browseShelfItem.recordId;
        this.thumbnails= this.buildThumbnailsArray(browseShelfItem.thumbnails);
    }

    private buildThumbnailsArray(thumbnailsObject: IBrowseShelfThumbnails){
        let thumbnails= [];
        if (!thumbnailsObject || !thumbnailsObject.url){
            return thumbnails;
        }
        let links: Array<string>= thumbnailsObject.url;
        for (let link of links){
            thumbnails.push({displayLabel: 'thumbnail', linkURL: link});
        }
        return thumbnails;
    }

    private getThumbnail(thumbnails: IBrowseShelfThumbnails): string{
        for (let url of thumbnails.url){
            if (endsWith(url, '.jpg')){
                return url;
            }
        }
    }
}


//put here all angular1 modules the service is using
export default [];


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/virtualBrowse/virtualBrowse.service.ts